import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {
  Form
} from 'react-bootstrap';
import cx from 'classnames';
import { Nav, NavDropdown } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AdminLoginForm.css';
import cs from '../../../components/commonStyle.css';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';
import Loader from '../../Common/Loader';
import AdminLogo from './arrow.svg';
import submit from './submit';
import validate from './validate';
import Link from '../../Link';
import { api, logoUploadDir } from '../../../config';
import { choseToTheme } from '../../../actions/currency/getCurrencyRates';
import { openHeaderModal } from '../../../actions/siteadmin/modalActions';
import HeaderModal from '../../HeaderModal/HeaderModal';
import { formatLocale } from '../../../helpers/formatLocale';

//Images
import LanguageIcon from '../../../../public/Icons/languageIcon.svg';
import selectedLightIcon from '../../../../public/Icons/lightModeOn.svg';
import selectedDarkIcon from '../../../../public/Icons/darkModeOn.svg';
import dropDownLightIcon from '../../../../public/Icons/lightModeOff.svg';
import dropDownDarkIcon from '../../../../public/Icons/darkModeOff.svg';
import MainSiteIcon from '../../../../public/Icons/mainSite.svg';
import arrowIcon from '../../../../public/Icons/loginArrowIcon.svg';
import adminLoginImage from '../../../../public/static/adminLeftimg.svg'


class AdminLoginForm extends Component {

  static defaultProps = {
    loading: false,
    siteName: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoad: true
    },
      this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    isBrowser && this.setState({
      isLoad: false
    });
  }

  handleChange(e) {
    const { openHeaderModal } = this.props;
    openHeaderModal('languageModal');
  }
  renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder }) => {
    const { formatMessage } = this.props.intl;
    return (
      <Form.Group>
        <label className={cx(cs.labelText, 'textWhite')} >{label}</label>
        <Form.Control {...input} placeholder={placeholder} type={type} className={cs.formControlInput} />
        {touched && error && <span className={cx(cs.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
      </Form.Group>
    )
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, loading, logo, selectedTheme, choseToTheme, currentLocale } = this.props;
    const { formatMessage } = this.props.intl;
    const { isLoad } = this.state;

    return (
      <div>
        <HeaderModal />
        <div className={s.loginMainBg}>
          <div className={s.bgPadding}>
            <div className={s.loginBg} style={{ backgroundImage: `url(${adminLoginImage})` }} />
          </div>
          <div className={s.leftPadding}>
            <div className={'adminLoginFormHeader'}>
              <Nav className={s.flexEnd}>
                <NavDropdown title={
                  <>
                    {
                      (selectedTheme && selectedTheme === "light") &&
                      <span className={s.selectedThemeColor}> <img src={selectedLightIcon} alt='' /> <FormattedMessage {...messages.lightMode} /></span>
                    }
                    {
                      (selectedTheme && selectedTheme === "dark") &&
                      <span className={s.selectedThemeColorDark}> <img src={selectedDarkIcon} alt='' /> <FormattedMessage {...messages.darkMode} /></span>
                    }
                  </>
                }

                  noCaret id="basic-nav-dropdown1" className={cx(s.nonBreakPointScreen, 'adminThemeHeader', 'loginFormHeader')}>
                  <NavDropdown.Item to="#" onClick={() => { choseToTheme('light') }} className={cx(s.themeIconDropDownLink, s.borderFirst, 'textWhite')}>
                    <div className={cx({ [s.selectedThemeColor]: selectedTheme === "light" }, s.themeIconSec)}>
                      {
                        (selectedTheme && selectedTheme === "light") ?
                          <img src={selectedLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> : <img src={dropDownLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                      }
                      <FormattedMessage {...messages.lightMode} />
                    </div>
                  </NavDropdown.Item>
                  <NavDropdown.Item to="#" onClick={() => { choseToTheme('dark') }} className={cx(s.themeIconDropDownLink, 'textWhite')}>
                    <div className={cx({ [s.selectedThemeColorDark]: selectedTheme === "dark" }, s.themeIconSec)}>
                      {
                        (selectedTheme && selectedTheme === "dark") ?
                          <img src={selectedDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> : <img src={dropDownDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                      }
                      <FormattedMessage {...messages.darkMode} />
                    </div>
                  </NavDropdown.Item>
                </NavDropdown>
                <Link noLink
                  onClick={(e) => this.handleChange(e)}
                  className={cx(s.siteColor, s.cursurPointer, 'textWhite', 'languageHeaderRTL', s.displayFlex)}>
                  <span className={cx(s.iconWidth, s.languageIcon, 'svgImg')}>
                    <img src={LanguageIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.iconTextPadding, 'iconTextPaddingRTL')}>
                    {formatLocale(currentLocale)}
                  </span>
                </Link>
                <Link to={'/'} onClick={() => this.openClose()} className={cx(s.Sitepadding, s.siteColor, 'textWhite', s.displayFlex)}>
                  <span className={cx(s.displayInlineBlock, s.vtrTop, s.iconWidth, 'svgImg')}>
                    <img src={MainSiteIcon} className={cx(s.sideMenuIcon, s.noFilter)} />
                  </span>
                  <span className={cx(s.displayInlineBlock, s.vtrMiddle, s.iconTextPadding, 'iconTextPaddingRTL')}>
                    <FormattedMessage {...messages.goToMainSite} />
                  </span>
                </Link>
              </Nav>
            </div>
            <div className={s.formInner}>
              <div className={s.loginTitleScetion}>
                {logo &&
                  <img
                    src={api.apiEndpoint + logoUploadDir + logo}
                  />
                }
                {!logo &&
                  <img
                    src={AdminLogo}
                  />
                }
                <p className={cx(cs.titleText, 'textWhite', cs.fontWightSemiBold, cs.paddingTop2)}><FormattedMessage {...messages.welcomeAdminLabel} /></p>
              </div>
              <div className={'loginInput'}>
                <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                  {error && <span className={cx(cs.errorMessage, 'errorRTL')}>{error}</span>}
                  <Field
                    name="email"
                    type="text"
                    component={this.renderField}
                    label={formatMessage(messages.email)}
                    placeholder={formatMessage(messages.emailaddress)}
                    labelClass={cs.labelText}
                    fieldClass={cx(cs.formControlInput)}
                  />
                  <Field
                    name="password"
                    type="password"
                    component={this.renderField}
                    label={formatMessage(messages.password)}
                    placeholder={formatMessage(messages.password)}
                    labelClass={cs.labelText}
                    fieldClass={cx(cs.formControlInput)}
                  />
                  <Form.Group className={cx(s.loginButton, 'loadingcsnRTL')}>
                    <Loader
                      type={"button"}
                      label={formatMessage(messages.login)}
                      show={loading}
                      buttonType={'submit'}
                      className={cx(cs.btnPrimary, s.fullWidth)}
                      disabled={submitting || loading || isLoad}
                      isSuffix={true}
                      image={arrowIcon}
                    />
                  </Form.Group>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

AdminLoginForm = reduxForm({
  form: 'AdminLoginForm', // a unique name for this form
  validate,
  onSubmit: submit
})(AdminLoginForm);

const mapState = (state) => ({
  loading: state.loader.AdminLogin,
  siteName: state?.siteSettings?.data?.siteName,
  logo: state?.siteSettings?.data?.homeLogo,
  selectedTheme: state.currency.theme,
  currentLocale: state.intl.locale,
});

const mapDispatch = {
  choseToTheme,
  openHeaderModal
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(AdminLoginForm)));
